import { TextField } from '@material-ui/core';
import React  from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { NUMBER_FORMAT } from '../../../utils/validate';

const KPIEntryForm = ({ kpi }) => {
  const { t } = useTranslation();

  return <>
    <Controller
      name='value'
      defaultValue=''
      rules={ {
        required: {
          value: true,
          message: 'required'
        },
        pattern: {
          value: NUMBER_FORMAT,
          message: 'notNumber'
        },
        min: {
          value: 0,
          message: 'isNegative'
        }
      } }
      render={ ({
        field: { onChange, value },
        fieldState: { error }
      }) => (
        <TextField
          label={ `${t('objective.kpi.entry.fields.value')} (${kpi.unit})` }
          value={ value }
          onChange={ onChange }
          margin='dense'
          fullWidth
          error={ !!error }
          helperText={ error?.message && t(`form.errors.${error.message}`) }
        />
      ) }
    />
    <Controller
      name='comment'
      defaultValue=''
      render={ ({ field: { onChange, value } }) => (
        <TextField
          label={ t('objective.kpi.entry.fields.comment') }
          value={ value }
          onChange={ onChange }
          margin='dense'
          fullWidth
        />
      ) }
    />
  </>;
};

export default KPIEntryForm;